import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', href: '/' },
    { label: '平台分类', href: '/category/all' },
    { label: '关于我们', href: '/about' },
  ],
  平台推荐: [
    { label: '樱花视频', href: '/category/all' },
    { label: '香蕉视频', href: '/category/all' },
    { label: '红桃视频', href: '/category/all' },
    { label: '蜜桃视频', href: '/category/all' },
    { label: '糖豆视频', href: '/category/all' },
  ],
  帮助支持: [
    { label: '使用指南', href: '/article/3' },
    { label: '安全须知', href: '/article/6' },
    { label: '常见问题', href: '/about' },
    { label: '联系我们', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">樱花视频</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              樱花视频汇集香蕉视频、红桃视频、蜜桃视频、糖豆视频等同类优质平台，提供高清免费在线观看推荐，海量电影电视剧全集不卡顿。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 樱花视频 - 版权所有。本站为视频平台推荐聚合网站，所有内容仅供参考。
            </p>
            <div className="flex items-center gap-5">
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">服务条款</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}